import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, styled, Typography } from '@mui/material'
import type { FC, PropsWithChildren, ReactNode } from 'react'

import { COLORS, unit } from '@hcr/pwa/components'

interface TileProps extends PropsWithChildren {
  cta: ReactNode
  icon: IconDefinition
  title: string
}

export const Tile: FC<TileProps> = ({ children, cta, icon, title }) => {
  return (
    <Container>
      <Header>
        <Typography variant='headlineS'>{title}</Typography>
        <HeaderIcon>
          <FontAwesomeIcon icon={icon} />
        </HeaderIcon>
      </Header>
      {children}
      <Footer>{cta}</Footer>
    </Container>
  )
}

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.vaalea['60%']};
`

const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${unit(5)};
  padding-top: ${unit(6.5)};
`

const HeaderIcon = styled(Box)`
  color: ${COLORS.burgundi[400]};
  font-size: ${unit(6)};
`

const Footer = styled(Box)`
  padding: ${unit(6.5)} ${unit(5)};
`
